export const FE_SORT_PARAM = 'sort';

// export const SORT_ORDER_DESC_SUFFIX = '-desc';
export const SORT_ORDER_DESC_PREFIX = '-';
